import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IotaTabsComponent } from '../iota-tabs.component';

@Component({
    standalone: false,
    selector: 'app-iota-tab',
    template: `
        <a
            class="bg-white tab tab-lifted transition text-base text-base-content hover:bg-primary-focus hover:text-primary-content border border-iota-outline hover:border-primary-focus !border-b-0 rounded-none !py-2.5 h-fit"
            [ngClass]="{ active: this.value === this.tabs.activeTab }"
            [attr.data-testid]="!!value ? 'iotaTab-' + value : null"
            (click)="activate()"
        >
            <div class="px-2">
                <ng-content></ng-content>
            </div>
        </a>
    `,
    styleUrls: ['./iota-tab.component.scss']
})
export class IotaTabComponent {
    @Input() value: any;

    @Output() tabActivated = new EventEmitter<any>();

    tabs: IotaTabsComponent;

    constructor(tabs: IotaTabsComponent) {
        this.tabs = tabs;
    }

    activate(): void {
        this.tabActivated.emit(this.value);
    }
}
